import { createContext } from 'react';

export const PlaceholderContext = createContext(false);
